import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr'; 
import { CustomErrorToastComponent } from 'projects/custom-error-toast/src/public-api';
@Component({
  selector: 'app-drop-box',
  templateUrl: './drop-box.component.html',
  styleUrls: ['./drop-box.component.scss']
})
export class DropBoxComponent implements OnInit {
  // client_id = 'uf6rnjmrsci7an6';
  // clientSecret = 'hqwemh6a4tuzcvn';
  client_id = '41wwpakr0kvrno0';
  clientSecret = 'i2wxe2fmgyxbgqe';
  dropboxData = [];
  dataSource = [];
  isAuth = false;
  displayedColumns: string[] = ['sno', 'name', 'client_modified', 'path_display', 'action'];
  host: string;
  constructor(
    private route: ActivatedRoute,
    public toster: ToastrService
  ) {
    this.host = window.location.protocol + '//' + window.location.host;
  }
  ngOnInit(): void {
    let dropboxAuthcode = this.route.snapshot.queryParamMap.get('code');
    if (dropboxAuthcode) {
      this.getAuthCode(dropboxAuthcode);
    }
    let auth = this.route.snapshot.queryParamMap.get('auth')
    if (auth == 'true') {
      this.isAuth = true;
      this.getDropboxFiles();
    }
  }
  onFileSelected() {
    var that = this;
    var fileInput: any = document.getElementById('file-input');
    var file = fileInput.files[0];
    var isStop = false;
    that.dataSource.forEach(item => {
      if (item.name == file.name) {
        that.toster.warning('Selected file already exists!', 'Warning');
        fileInput.value = null;
        isStop = true;
        return false;
      }
    });
    if (isStop) return; 
    var xhr = new XMLHttpRequest();
    var uploadUrl = 'https://content.dropboxapi.com/2/files/upload';
    var folderPath = '';
    var accessToken = localStorage.getItem('dropbox_token');
    xhr.open('POST', uploadUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/octet-stream');
    xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
    xhr.setRequestHeader('Dropbox-API-Arg', JSON.stringify({
      path: folderPath + '/' + file.name,
      mode: 'add',
      autorename: true,
      mute: false
    }));
    xhr.onload = function () {
      fileInput.value = null;
      if (xhr.status === 200) {
        that.toster.success('File uploaded successfully!', 'Success');
        that.getDropboxFiles();
      } else {
        CustomErrorToastComponent.showErrorToast(that.toster, 'Error in uploading file process.');
      }
    };
    xhr.send(file);
  }
  downloadDoc(element) {
    var getLinkParams = { 'path': element.path_lower }
    var getTemporaryLinkUrl = 'https://api.dropboxapi.com/2/files/get_temporary_link';
    var getLinkXhr = new XMLHttpRequest();
    getLinkXhr.open('POST', getTemporaryLinkUrl, true);
    getLinkXhr.setRequestHeader('Content-Type', 'application/json');
    getLinkXhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('dropbox_token'));
    getLinkXhr.onload = function () {
      if (getLinkXhr.status === 200) {
        var linkResponse = JSON.parse(getLinkXhr.responseText);
        var link = document.createElement("a");
        link.setAttribute('download', '');
        link.href = linkResponse.link;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    };
    getLinkXhr.send(JSON.stringify(getLinkParams));
  }
  deleteDoc(ele) { }
  addDropBox() {
    let dropbox_auth = 'https://www.dropbox.com/oauth2/authorize';
    let redirect_uri = this.host + '/beneficiary-landing/beneficiaries/profile/profile-details?tab=dropbox';
    let token_access_type = 'offline';
    let response_type = 'code';
    let url = `${dropbox_auth}?client_id=${this.client_id}&token_access_type=${token_access_type}&response_type=${response_type}&redirect_uri=${redirect_uri}`;
    let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no, width=700,height=700,left=450,top=40`;
    window.open(`${url}`, 'auth', params);
  }
  getDropboxFiles() {
    //this.dataSource=[]; 
    var that = this;
    var location = window.location.href.split('?');
    var redirect = location[0] + '?tab=dropbox';
    var xhr = new XMLHttpRequest();
    var url = 'https://api.dropboxapi.com/2/files/list_folder';
    var params = 'path=' +
      '&recursive=false' +
      '&include_media_info=false' +
      '&include_deleted=false' +
      '&include_has_explicit_shared_members=false' +
      '&include_mounted_folders=true';
    var body = {
      "path": "",
      "recursive": false,
      "include_media_info": false,
      "include_deleted": false,
      "include_has_explicit_shared_members": false,
      "include_mounted_folders": true
    }
    // Set up the request
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('dropbox_token'));
    xhr.send(JSON.stringify(body));
    xhr.onload = function () {
      if (xhr.status === 200) {
        var response = JSON.parse(xhr.responseText);
        var filter = response.entries.filter(item => item['.tag'] !== 'folder');
        localStorage.setItem('dropbox_data', JSON.stringify(filter));
        setTimeout(() => {
          that.dataSource = filter;
        }, 400);
      }
    };
    xhr.send(params);
  }
  getAuthCode(auth) {
    let that = this;
    var location = window.location.href.split('?');
    var redirect = location[0] + '?tab=dropbox&auth=true';
    let authorizationCode = auth;
    let redirect_uri = this.host + '/beneficiary-landing/beneficiaries/profile/profile-details?tab=dropbox';
    // Define the request parameters
    var xhr = new XMLHttpRequest();
    var url = 'https://api.dropbox.com/oauth2/token';
    var params = 'code=' + authorizationCode +
      '&grant_type=authorization_code' +
      '&client_id=' + this.client_id +
      '&client_secret=' + this.clientSecret +
      '&redirect_uri=' + redirect_uri;
    // Set up the request
    xhr.open('POST', url + '?' + params, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = function () {
      if (xhr.status === 200) {
        var response = JSON.parse(xhr.responseText);
        var accessToken = response.access_token;
        localStorage.setItem('dropbox_token', accessToken);
        window.opener.location.href = redirect;
        setTimeout(() => {
          window.close();
        }, 100);
      }
    }
    xhr.send(params);
  }
}

